import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

// Unwrap the paginator's `data` array; tolerate an already-flat array or a nullish
// response (returning []). Exported so the transform can be unit-tested directly.
export const unwrapManagersResponse = (response) => (Array.isArray(response?.data) ? response.data : (response ?? []));

export const managersApiSlice = createApi({
  reducerPath: 'managersApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    getManagers: builder.query({
      // The /managers endpoint is paginated. This query is consumed by selects
      // and reports that expect the full list as a flat array, so request a
      // large page and unwrap the paginator's `data` here.
      query: ({ apiManager, ...rest }) => apiManager.get({ per_page: 100, ...rest }),
      transformResponse: unwrapManagersResponse,
    }),
  }),
  serializeQueryArgs,
});

export const { useGetManagersQuery } = managersApiSlice;
